import { Box, Button, Dialog, DialogContent, DialogTitle, ModalProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import BaseRow from '../base-row/BaseRow';

type ConfirmDialogProps = Omit<ModalProps, 'children'> & {
  title?: string;
  description?: string;
  confirm?: string;
  cancel?: string;
  btnConfirmClassName?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
};

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const { t } = useTranslation(['admin/component']);
  return (
    <Dialog
      open={props.open}
      onClose={() => {
        if (props?.onCancel) props.onCancel();
      }}
      className='text-center'
      PaperProps={{
        sx: {
          minWidth: '400px',
        },
      }}
    >
      <DialogTitle className='text-[#161A1F] text-xl font-semibold bg-white'>{props.title}</DialogTitle>
      <DialogContent>
        {props?.description ? (
          <Box
            className='mb-[20px] text-[#161A1F] text-base font-normal'
            dangerouslySetInnerHTML={{ __html: props?.description }}
          ></Box>
        ) : null}
        <BaseRow className='!justify-between gap-2'>
          <Button
            variant='outlined'
            className='w-full bg-[#D7DEE7] border-0 !border-inherit text-[#404854] text-base font-semibold'
            onClick={() => {
              if (props?.onCancel) props.onCancel();
            }}
          >
            {props?.cancel || t('confirmDialog.cancel')}
          </Button>
          <Button
            variant='contained'
            color='secondary'
            className={`w-full bg-[#C62828] text-base font-semibold ${props.btnConfirmClassName}`}
            onClick={() => {
              if (props?.onConfirm) props.onConfirm();
            }}
          >
            {props?.confirm || t('confirmDialog.confirm')}
          </Button>
        </BaseRow>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ConfirmDialog);
